import React from "react";
import xss from "xss";

const options = {
  whiteList: {
    ...xss.whiteList,
    iframe: ["src", "width", "height", "allow", "allowfullscreen", "frameborder", "scrolling", "title"],
    img: ["src", "alt", "width", "height"],
    video: ["src", "controls", "width", "height", "autoplay", "loop", "muted", "poster"],
    a: ["href", "name", "target", "rel"],
    svg: ["xmlns", "viewBox", "fill", "width", "height"],
    path: ["d", "fill", "fill-rule", "clip-rule"],
    circle: ["cx", "cy", "r", "fill"],
    rect: ["width", "height", "rx", "fill"],
    line: ["x1", "y1", "x2", "y2", "stroke"],
    polyline: ["points", "stroke"],
    polygon: ["points", "stroke"],
    figure: [],
    figcaption: []
  },
  safeAttrValue: function (tag, name, value, cssFilter) {
    if (tag === 'iframe' && name === 'src') {
      return value;
    }
    return xss.safeAttrValue(tag, name, value, cssFilter);
  },
  onIgnoreTagAttr: function (tag, name, value, isWhiteAttr) {
    if (name === 'style' || name === 'class' || name === 'id' || name.startsWith('data-')) {
      return name + '="' + xss.escapeAttrValue(value) + '"';
    }
  },
  stripIgnoreTag: true,
  stripIgnoreTagBody: ["script"]
};

const myxss = new xss.FilterXSS(options);

const SafeHTML = ({ html, className, as: Component = "div", style }) => {
  const cleanHTML = html ? myxss.process(html) : "";

  return (
    <Component
      style={style}
      className={className}
      dangerouslySetInnerHTML={{ __html: cleanHTML }}
    />
  );
};

export default SafeHTML;
